import arrow_black_2x from '@client/shared/styles/assets/indicators/factuals-icon-black@2x.png';
import arrow_black from '@client/shared/styles/assets/indicators/factuals-icon-black.png';
import arrow_white from '@client/shared/styles/assets/indicators/factuals-icon-off-white.png';
import arrow_white_2x from '@client/shared/styles/assets/indicators/factuals-icon-off-white@2x.png';
import icon_menu from '@client/shared/styles/assets/indicators/icon-menu.png';
import icon_arrowdown from '@client/shared/styles/assets/indicators/icon-arrowdown.png';
import graphic_arrows from '@client/shared/styles/assets/indicators/graphic-arrows.png';
import graphic_arrows_2x from '@client/shared/styles/assets/indicators/graphic-arrows@2x.png';
import play_icon_white from '@client/shared/styles/assets/indicators/icon-arrow-left-white.svg';
import arrow_purple from '@client/shared/styles/assets/indicators/icon_play_purple.png';

export default {
  arrow_black,
  arrow_black_2x,
  arrow_white,
  arrow_white_2x,
  icon_menu,
  icon_arrowdown,
  graphic_arrows,
  graphic_arrows_2x,
  play_icon_white,
  arrow_purple,
};
